module.exports = __webpack_public_path__ + "static/media/swirepay.1c6af8eb.png";